import React, { InputHTMLAttributes, KeyboardEventHandler } from 'react';
import { WrappedFieldProps } from 'redux-form';

import styles from './style.css';

interface InputFieldProps extends WrappedFieldProps {
  readonly type?: InputHTMLAttributes<HTMLInputElement>['type'];
  readonly maxLength?: InputHTMLAttributes<HTMLInputElement>['maxLength'];
  readonly placeholder?: InputHTMLAttributes<HTMLInputElement>['placeholder'];
  readonly onKeyPress?: InputHTMLAttributes<HTMLInputElement>['onKeyPress'];
  readonly setOnlyNumber: KeyboardEventHandler<HTMLInputElement>;
}

export const InputField = (field: InputFieldProps) => {
  return (
    <div>
      <input
        {...field.input}
        type={field.type || 'text'}
        maxLength={field.maxLength}
        className={`form-control ${styles['input-style']} ${
          field.meta.touched && field.meta.error ? styles['input-error'] : ''
        }`}
        placeholder={field.placeholder}
        onKeyPress={(e) => (field.onKeyPress ? field.setOnlyNumber(e) : '')}
      />
      <small className={styles.error}>
        {field.meta.touched ? field.meta.error : ''}
      </small>
    </div>
  );
};

interface PasswordFieldProps extends WrappedFieldProps {
  readonly type?: InputHTMLAttributes<HTMLInputElement>['type'];
  readonly maxLength?: InputHTMLAttributes<HTMLInputElement>['maxLength'];
  readonly placeholder?: InputHTMLAttributes<HTMLInputElement>['placeholder'];
  readonly onKeyPress?: InputHTMLAttributes<HTMLInputElement>['onKeyPress'];
  readonly setOnlyNumber: KeyboardEventHandler<HTMLInputElement>;
}

export const PasswordField = (field: PasswordFieldProps) => {
  return (
    <div>
      <input
        {...field.input}
        type={field.type || 'password'}
        maxLength={field.maxLength}
        className={`form-control ${styles['input-style']} ${
          styles['password-field']
        } ${
          field.meta.touched && field.meta.error ? styles['input-error'] : ''
        }`}
        placeholder={field.placeholder}
        onKeyPress={(e) => (field.onKeyPress ? field.setOnlyNumber(e) : '')}
      />
      <small
        className={`${
          field.meta.error && field.meta.touched
            ? styles.error
            : styles['password-msg']
        }`}
      >
        {field.meta.error && field.meta.touched
          ? field.meta.error
          : 'Must contains both lowercase and uppercase characters, at least one number, and minimum 8 characters'}
      </small>
    </div>
  );
};

interface EmailFieldProps extends WrappedFieldProps {
  readonly maxLength?: InputHTMLAttributes<HTMLInputElement>['maxLength'];
}

export const EmailField = (field: EmailFieldProps) => {
  return (
    <div>
      <input
        {...field.input}
        type="text"
        maxLength={field.maxLength}
        className={`form-control ${styles['input-style']} ${
          field.meta.touched && field.meta.error ? styles['input-error'] : ''
        }`}
        autoCorrect="off"
        autoCapitalize="off"
        spellCheck="false"
        placeholder="Email"
      />
      <small className={styles.error}>
        {field.meta.touched ? field.meta.error : ''}
      </small>
    </div>
  );
};
